import { isCNTLD } from "../utils/helpers";
import axios from "axios";

export const setCookie = (value, cookieName) => {
    document.cookie = `${cookieName}=${value}; expires=${new Date(
        new Date().getTime() + 365 * 24 * 60 * 60 * 1000
    ).toUTCString()}; domain=${isCNTLD() ? COOKIE_DOMAIN_CN : COOKIE_DOMAIN}; path=/`;
};

export const getUserGeoInfo = async () => {
    if (sessionStorage.getItem(GEO_INFO_ITEM_NAME)) {
        return JSON.parse(sessionStorage.getItem(GEO_INFO_ITEM_NAME));
    }
    const { data } = await axios.get(`${GEO_ENDPOINT}`);
    const countryCode = data?.gfnServiceInfo?.clientCountryCode;
    const userGeoInfo = { countryCode };
    sessionStorage.setItem(GEO_INFO_ITEM_NAME, JSON.stringify(userGeoInfo));
    return userGeoInfo;
};

export const base64UrlToBase64 = (base64Url) => {
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
        base64 += "=";
    }
    return base64;
};
